<template>
<div
    class="mdc-dialog__surface"
    role="alertdialog"
    aria-modal="true"
    :aria-labelledby="`${id}-title`"
    :aria-describedby="`${id}-content`">
    <h2
        v-if="title"
        :id="`${id}-title`"
        class="mdc-dialog__title"
        v-html="title"></h2>
    <div
        :id="`${id}-content`"
        class="mdc-dialog__content">
        <slot>
            <div
                v-if="Array.isArray(content)"
                :class="$style.content">
                <p
                    v-for="(p, index) in content"
                    :key="`p-${index}`"
                    v-html="p"></p>
            </div>
            <p
                v-else
                :class="$style.content"
                v-html="content"></p>
        </slot>
    </div>
    <icon-button
        v-if="hasCloseButton"
        icon="ico_close"
        class="mdc-dialog__close"
        @click.native="onClickCloseButton" />
    <div
        v-if="actions && actions.length"
        :class="['mdc-dialog__actions', isActionsCenter && 'center']">
        <div>
            <app-button
                v-for="(
                    {
                        action = null,
                        async_action = null,
                        disabled = null,
                        label,
                        autofocus,
                        tagName = 'button',
                        href,
                        color
                    },
                    index
                ) in actions"
                :key="action"
                class="mdc-dialog__button"
                :tag-name="tagName"
                :color="color || getButtonColor(index, actions.length)"
                :data-mdc-dialog-action="action"
                :data-mdc-dialog-async-action="async_action"
                :data-mdc-dialog-initial-focus="!!autofocus"
                :label="label"
                :disabled="disabled"
                :href="href"
                @click.native="onClickButton" />
        </div>
    </div>
</div>
</template>

<script>
import AppButton from "@/components/AppButton.vue";
import IconButton from "@/components/mdc/IconButton.vue";
export default {
    components: { AppButton, IconButton },
    filters: {
        unelevated(i, length, unelevated) {
            return unelevated || i === length - 1;
        },
        outlined(i, length, unelevated) {
            return !unelevated && i < length - 1;
        }
    },
    props: {
        options: { type: Object, default: () => ({}) }
    },
    computed: {
        ...[
            "id",
            "title",
            "content",
            "actions",
            "hasCloseButton",
            "isActionsCenter"
        ].reduce((result, key) => {
            result[key] = {
                get() {
                    const { options } = this;
                    return options && options[key];
                }
            };
            return result;
        }, {})
    },
    methods: {
        onClickButton({ target }) {
            const $btn = target.closest(".mdc-dialog__button");
            if (!$btn) return;
            const {
                mdcDialogAction: action,
                mdcDialogAsyncAction: asyncAction
            } = $btn.dataset;
            if (!action && asyncAction) this.$emit("click", asyncAction);
        },
        getButtonColor(i, length) {
            return i === length - 1 ? "primary" : "light";
        },
        onClickCloseButton(e) {
            this.$emit("close");
            document.body.classList.remove("mdc-dialog-scroll-lock");
            this.$nc(e, "pop.close");
        }
    }
};
</script>

<style lang="scss">
@use "@material/button";
@use "@material/typography/typography";
@use "@/assets/scss/variables" as v;

h2.mdc-dialog__title {
    font-weight: bold;
    padding: 8px 30px;
}

.mdc-dialog__content {
    white-space: pre-line;
    padding: 5px 30px 20px !important;
    p {
        font-size: typography.px-to-rem(14px);
        line-height: 1.4;
        margin: 0;
    }
}

.mdc-icon-button.mdc-dialog__close {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #5b5b5b;
    width: 12px;
    height: 12px;
    margin: 0;
    padding: 0;
    svg {
        width: 100%;
        height: 100%;
        color: #5b5b5b;
    }
    .mdc-icon-button__ripple {
        display: none;
    }
}

.mdc-dialog__actions {
    .mdc-button[disabled] {
        opacity: 0.4;
    }
    &.center {
        display: flex;
        justify-content: center;
    }
}
</style>

<style lang="scss" module>
@use "@/assets/scss/variables" as v;

:global(.mdc-dialog__content) {
    .content {
        width: calc(400px - (#{v.$dialog-padding} * 2));
        max-width: 100%;
    }
}
</style>
